import { render, staticRenderFns } from "./BranchStatusHistoryTab.vue?vue&type=template&id=523db2f0&scoped=true"
import script from "./BranchStatusHistoryTab.vue?vue&type=script&lang=js"
export * from "./BranchStatusHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./BranchStatusHistoryTab.vue?vue&type=style&index=0&id=523db2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523db2f0",
  null
  
)

export default component.exports